// extracted by mini-css-extract-plugin
module.exports = {"container-form":"DynamicForm_container-form__rtS3l","button":"DynamicForm_button__rgG0U"};